// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 校验用户服务权限 GET /vip/permission/check */
export async function vipPermissionCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vipPermissionCheckUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/vip/permission/check', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户已开通的服务详情 GET /vip/service/list */
export async function vipServiceListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vipServiceListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVipServiceInfo>('/vip/service/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
